import { useState } from "react";

export const ImageWithFallback = ({ src, alt, style, ...props }) => {
  const [imgSrc, setImgSrc] = useState(src);

  return (
    <img
      alt={alt}
      src={imgSrc}
      style={style}
      onError={() => setImgSrc("../../../public/broken-image.png")}
      {...props}
    />
  );
};
